/* Package JSON Import will be here */
import React, { Component } from "react";
import { connect } from "react-redux";
import { Card, Row, Col, Input, Button, Badge, Typography, Divider } from "antd";
import _ from "lodash";
import { bindActionCreators } from "redux";
import { getTranslate } from "react-localize-redux";
/* Package JSON Import will be here */

/* Project Import will be here */
import { uploadReturnQty } from "reducers/salesReturn/salesReturnSummary";
import { updateExchangeReturnSummary } from "reducers/exchange/exchangeReturnSummary"
import { ButtonSpinner } from "components/Spinner";
import Constants from "../../utilities/appConstants";
import { errorToast } from "utilities/utils";
/* Project Import will be here */

/* Const,Let & Var will be here */
const { Text } = Typography;
/* Const,Let & Var will be here */

class SalesReturnEntry extends Component {
  constructor(props) {
    super(props);

    this.state = {
      reasonQtyList: [],
      isQtyModified: false
    };
  }

  componentDidMount = () => {
    const SelectedPageType = (this.props.pageType === Constants.EXCHANGE_RETURN_PRODUCT_LIST) ? Constants.EXCHANGE_RETURN_REASON : Constants.SALES_RETURN_REASON;

    /* Check for the reason master data available */
    if (this.props.common[SelectedPageType].data.length > 0) {
      /* form the dynamic state for the dynamic reason master data */
      let selectedProductReturnQty = [];

      /* Loop the dynamic reason master data and form the array */
      _.forEach(this.props.common[SelectedPageType].data, o => {
        let selectedPieceQty = 0;
        let selectedCaseQty = 0;

        /* Check for the qty already added */
        const selectedProductSummary = _.filter(this.props.returnSummary.data, a => {
          return a.ProductId === this.props.selectedProduct.ProductId
        });

        if (selectedProductSummary.length > 0) {
          const selectedReasonQty = _.find(selectedProductSummary[0].Reasons, b => {
            return b.ReasonId === o.Id
          });

          if (selectedReasonQty !== undefined) {
            const selectedProduct = this.props.selectedProduct;

            if (this.props.appSettings.isEnableSalesReturnCase) {
              /* Get case count */
              selectedCaseQty = Math.floor(selectedReasonQty.Qty / selectedProduct.ConversionQty);

              /* Get remaining piece count */
              selectedPieceQty = (selectedReasonQty.Qty % selectedProduct.ConversionQty);
            }
            else {
              selectedPieceQty = selectedReasonQty.Qty;
            }
          }
        }

        selectedProductReturnQty.push({
          reasonId: o.Id,
          reasonName: o.Name,
          selectedPieceQty: selectedPieceQty,
          selectedCaseQty: selectedCaseQty
        })
      });

      this.setState({
        reasonQtyList: selectedProductReturnQty
      });
    }
  }

  changeReasonQuantity = (selectedIndex, isPieceQtyChanged, value, isIncrement = null) => {
    let tempReasonList = _.sortBy(this.state.reasonQtyList, 'reasonName');

    /* Update the selected reason qty */
    let selectedReason = _.find(tempReasonList, (o, index) => {
      return index === selectedIndex;
    });

    /* Update case and piece string empty value to 0 */
    if (selectedReason.selectedPieceQty === "")
      selectedReason.selectedPieceQty = 0;
    if (selectedReason.selectedCaseQty === "")
      selectedReason.selectedCaseQty = 0;

    if (isIncrement === null) {
      if (isPieceQtyChanged) {
        selectedReason.selectedPieceQty = value === 0 ? "" : value;
      }
      else {
        selectedReason.selectedCaseQty = value === 0 ? "" : value;
      }
    }
    else {
      if (isPieceQtyChanged) {
        if (isIncrement)
          selectedReason.selectedPieceQty = selectedReason.selectedPieceQty < 9999 ? (selectedReason.selectedPieceQty + 1) : selectedReason.selectedPieceQty;
        else
          selectedReason.selectedPieceQty = selectedReason.selectedPieceQty > 0 ? selectedReason.selectedPieceQty - 1 : 0;
      }
      else if (!isPieceQtyChanged)
        if (isIncrement)
          selectedReason.selectedCaseQty = selectedReason.selectedCaseQty < 9999 ? (selectedReason.selectedCaseQty + 1) : selectedReason.selectedCaseQty;
        else
          selectedReason.selectedCaseQty = selectedReason.selectedCaseQty > 0 ? selectedReason.selectedCaseQty - 1 : 0;

    }
    /* Change the updated qty in the state */
    this.setState({
      reasonQtyList: tempReasonList,
      isQtyModified: true
    });
  }

  onChangeQty = (e, selectedIndex, isPieceQtyChanged) => {
    /* Check for only number to be entered */
    const { value } = e.target;
    const reg = /^-?\d*(\.\d*)?$/;
    if ((!isNaN(value) && reg.test(value)) || value === '') {
      const integerCount = value !== "" ? parseInt(value, 10) : 0;
      this.changeReasonQuantity(selectedIndex, isPieceQtyChanged, integerCount)
    }
  };

  updateEntry = () => {
    if (this.state.isQtyModified) {
      /* Check empty string in reason qty list  */
      const reasonQtyListTemp = _.forEach(this.state.reasonQtyList, o => {
        o.selectedPieceQty = o.selectedPieceQty === "" ? 0 : o.selectedPieceQty;
        o.selectedCaseQty = o.selectedCaseQty === "" ? 0 : o.selectedCaseQty;
      });

      if (this.props.pageType === Constants.EXCHANGE_RETURN_PRODUCT_LIST) {
        this.props.actions.updateExchangeReturnSummary(this.props.selectedProduct, reasonQtyListTemp);
      }
      else {
        /* Upload the updated count to the server */
        this.props.actions.uploadReturnQty(this.props.selectedProduct, reasonQtyListTemp);
      }

      /*  in product detail page sales return onClick */
      this.setState({ isQtyModified: false }, () => {
        if (this.props.onCloseReturnQtyModal !== undefined)
          this.props.onCloseReturnQtyModal();
      });
    }
    else {
      errorToast({ content: this.props.translate("common.alerts.error.salesReturnNoProductUpdate") });
    }
  }

  render() {
    const { translate, selectedProduct, returnSummary, pageType, appSettings } = this.props;
    return (
      <React.Fragment>
        {/* Product Name */}
        {pageType !== Constants.PRODUCT_DETAILS &&
          <div className="p-2">
            <Text>{translate("products.productLabel.addQtyProductText")} - {<Text strong>{selectedProduct.ProductName}</Text>}</Text>
          </div>
        }

        {(appSettings.isEnableSalesReturnCase && appSettings.isShowConversionQtyLabel) &&
          <div className="p-2">
            <span>
              <Badge color="orange" />
              <Text className="font-12">{`${translate("products.productLabel.ConversionQtyCase")} : ${selectedProduct.ConversionQty} ${translate("products.productLabel.unit")}`}</Text>
            </span>
          </div>
        }

        {/* Reason data card */}
        {_.sortBy(this.state.reasonQtyList, 'reasonName').map((reason, index) => (
          <React.Fragment key={reason.reasonId}>
            <Card className="ant-card-with-box-shadow w-100 mb-2 border-radius-15">
              <div className="font-weight-bold">{reason.reasonName}</div>

              <Divider />

              <Row className="p-1">
                {appSettings.isEnableSalesReturnCase &&
                  <Col span={12} className="p-1">
                    {translate("products.productLabel.caseQty")}
                    <div className="d-flex align-items-center  mt-1">
                      <Button className="product-qul mr-1"
                        icon={<i className="icon-minus" />}
                        size="small"
                        onClick={(e) => this.changeReasonQuantity(index, false, 0, false)}
                      />
                      <Input
                        className="w-85px"
                        inputMode="numeric"
                        maxLength={4}
                        value={reason.selectedCaseQty}
                        onChange={(e) => this.onChangeQty(e, index, false, false)}
                        placeholder={translate("products.productLabel.caseQty")}
                      />
                      <Button className="product-qul ml-1"
                        icon={<span className="card-plus-sign">+</span>}
                        size="small"
                        onClick={(e) => this.changeReasonQuantity(index, false, 0, true)}
                      />
                    </div>

                  </Col>
                }

                {appSettings.isEnableSalesReturnPiece &&
                  <Col span={12} className="p-1">
                    {translate("products.productLabel.pieceQty")}
                    <div className="d-flex align-items-center mt-1">
                      <Button className="product-qul mr-1"
                        icon={<i className="icon-minus" />}
                        size="small"
                        onClick={(e) => this.changeReasonQuantity(index, true, 0, false)}
                      />
                      <Input
                        className="w-85px"
                        inputMode="numeric"
                        maxLength={4}
                        value={reason.selectedPieceQty}
                        onChange={(e) => this.onChangeQty(e, index, true, true)}
                        placeholder={translate("products.productLabel.pieceQty")}
                      />
                      <Button className="product-qul ml-1"
                        icon={<span className="card-plus-sign">+</span>}
                        size="small"
                        onClick={(e) => this.changeReasonQuantity(index, true, 0, true)}
                      />
                    </div>
                  </Col>
                }
              </Row>
            </Card>
          </React.Fragment >
        ))}

        <Row justify="center" className="p-2 mt-2">
          <Col span={12} className="text-center">
            <Button
              block
              disabled={returnSummary.returnUpload.isLoading}
              shape="round"
              onClick={this.updateEntry}
              type="primary"
            >
              {translate("common.buttons.updateEntry")}
              {returnSummary.returnUpload.isLoading && <ButtonSpinner />}
            </Button>
          </Col>
        </Row>
      </React.Fragment >
    );
  }
}

const mapStateToProps = (state) => {
  return {
    common: state.common,
    translate: getTranslate(state.locale),
    appSettings: state.appSettings
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    actions: bindActionCreators(
      {
        uploadReturnQty,
        updateExchangeReturnSummary
      },
      dispatch
    ),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(SalesReturnEntry);